import { VideoQuality } from 'livekit-client'

export type PubQuality = 'high' | 'medium' | 'low'

export function stepPublishQuality(opts: {
  current: PubQuality
  limited: boolean
  healthyTicks: number
  limitedTicks: number
}): { next: PubQuality; healthyTicks: number; limitedTicks: number } {
  const healthyTicks = opts.limited ? 0 : opts.healthyTicks + 1
  const limitedTicks = opts.limited ? opts.limitedTicks + 1 : 0

  let next = opts.current
  if (opts.current === 'high' && limitedTicks >= 2) next = 'medium'
  if (opts.current === 'medium' && limitedTicks >= 3) next = 'low'
  if (opts.current === 'low' && healthyTicks >= 6) next = 'medium'
  if (opts.current === 'medium' && healthyTicks >= 6) next = 'high'

  return next === opts.current
    ? { next, healthyTicks, limitedTicks }
    : { next, healthyTicks: 0, limitedTicks: 0 }
}

export function videoQualityFor(quality: PubQuality): VideoQuality {
  return { high: VideoQuality.HIGH, medium: VideoQuality.MEDIUM, low: VideoQuality.LOW }[quality]
}
